export const translations = {
  en: {
    // Common
    loading: 'Loading...',
    error: 'Error',
    tryAgain: 'Try Again',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    close: 'Close',
    
    // Navigation
    home: 'Home',
    menu: 'Menu',
    cart: 'Cart',
    checkout: 'Checkout',
    orders: 'My Orders',
    profile: 'Profile',
    
    // Home Page
    restaurantMenu: 'Restaurant Menu',
    restaurantTagline: 'We have listed the best dishes for you',
    popularItems: 'Popular Items',
    mostPopular: 'Most Popular',
    seeAll: 'See All',
    allDishes: 'All Dishes',
    popularDishes: 'Popular Dishes',
    bestMealOfTheDay: 'BEST MEAL OF THE DAY',
    exclusiveDeals: 'EXCLUSIVE DEALS',
    orderNow: 'ORDER NOW',
    searchFoodPlaceholder: 'Search food...',
    filter: 'Filter',
    sortBy: 'Sort by',
    sortDefault: 'Default',
    sortPriceLowToHigh: 'Price: Low to High',
    sortPriceHighToLow: 'Price: High to Low',
    sortNameAtoZ: 'Name: A to Z',
    sortCategoryAtoZ: 'Categories A to Z',
    sort: 'Sort',
    filterByCategory: 'Filter by category',
    applyFilters: 'Apply',
    selectAllCategories: 'All categories',
    allItems: 'All Items',
    browseMenu: 'Browse Menu',
    noItemsFound: 'No items found',
    searchMenuItems: 'Search menu items...',
    
    // Cart
    yourCart: 'Your Cart',
    cartEmpty: 'Your cart is empty',
    addItems: 'Add some delicious items to get started!',
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal',
    tax: 'Tax',
    vat: 'VAT',
    serviceCharge: 'Service Charge',
    total: 'Total',
    proceedToCheckout: 'Proceed to Checkout',
    confirmOrder: 'Confirm Order',
    fullNameOptional: 'Full Name (optional)',
    phoneNumberRequired: 'Phone Number',
    mobileRequired: 'Phone number is required',
    phone10Digits: 'Please enter a valid 10-digit phone number',
    size: 'Size',
    addons: 'Add-ons',
    note: 'Note',
    
    // Checkout
    customerInformation: 'Customer Information',
    mobileNumber: 'Mobile Number',
    name: 'Name',
    optional: 'Optional',
    tableNumber: 'Table Number',
    tableNumberPlaceholder: 'Table number if dining in',
    specialInstructions: 'Special Instructions',
    specialInstructionsPlaceholder: 'Any special requests or instructions?',
    placeOrder: 'Place Order',
    placingOrder: 'Placing Order...',
    required: 'required',
    validMobileNumber: 'Please enter a valid mobile number',
    
    // Order Confirmation
    orderPlaced: 'Order Placed!',
    orderPlacedMessage: "Thank you for your order. We'll prepare it right away.",
    orderSuccess: 'Order received',
    yourOrder: 'Your Order',
    showQRToWaiter: 'Show this QR code to your waiter',
    waiterScanHint: 'Waiter will scan this to add items to your table order',
    orderNumber: 'Order Number',
    needHelp: 'Need help?',
    viewMyOrders: 'View My Orders',
    backToMenu: 'Back to Menu',
    
    // Item Detail
    foodDetails: 'Food Details',
    quantity: 'Quantity',
    addToCart: 'Add to Cart',
    addToOrder: 'ADD TO ORDER',
    viewCart: 'View Cart',
    ingredients: 'Ingredients',
    recommendedSides: 'Recommended Sides',
    weAlsoHave: 'We also have',
    allergens: 'Allergens',
    specialRequests: 'Special Requests',
    specialRequestsPlaceholder: 'Any special requests?',
    
    // My Orders
    viewMyOrdersTitle: 'View My Orders',
    enterPhoneAndOrder: 'Enter your phone number and order number to view your orders',
    phoneNumber: 'Phone Number',
    orderNumberInput: 'Order Number',
    orderNumberPlaceholder: 'ORD-20250109-1234',
    orderNumberHint: 'You can find this on your order confirmation page',
    viewOrders: 'View Orders',
    verifying: 'Verifying...',
    invalidPhoneOrOrder: 'Invalid phone number or order number. Please check and try again.',
    noOrdersFound: 'No Orders Found',
    noOrdersMessage: "You haven't placed any orders yet.",
    orderDetails: 'Order Details',
    leaveReviewOnGoogle: 'Leave us a review on Google Maps',
    leaveReviewOnLine1: 'Leave us a review on',
    leaveReviewOnLine2: 'Google Maps',
    items: 'Items',
    item: 'item',
    status: 'Status',
    pending: 'Pending',
    confirmed: 'Confirmed',
    preparing: 'Preparing',
    ready: 'Ready',
    completed: 'Completed',
    cancelled: 'Cancelled',
    
    // Category View
    category: 'Category',
    noItemsInCategory: 'No items in this category',
    
    // Errors
    failedToLoad: 'Failed to load',
    failedToLoadMenu: 'Failed to load menu',
    failedToPlaceOrder: 'Failed to place order. Please try again.',
    failedToLoadOrders: 'Failed to load orders',

    // Reservation
    reservation: 'Reservation',
    fullName: 'Full Name',
    email: 'Email',
    guests: 'Guests',
    date: 'Date',
    time: 'Time',
    reserve: 'Reserve',
    reservationSuccess: 'Reservation request sent',
    reservationSuccessMessage: "We'll confirm your reservation shortly.",
    reservationSuccessHint: "We'll notify you once your reservation is confirmed. You can also call us if you have any questions.",
    reservationFailed: 'Failed to send reservation. Please try again.',
  },
  ar: {
    // Common
    loading: 'جاري التحميل...',
    error: 'خطأ',
    tryAgain: 'حاول مرة أخرى',
    back: 'رجوع',
    next: 'التالي',
    submit: 'إرسال',
    cancel: 'إلغاء',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    search: 'بحث',
    close: 'إغلاق',
    
    // Navigation
    home: 'الرئيسية',
    menu: 'القائمة',
    cart: 'السلة',
    checkout: 'الدفع',
    orders: 'طلباتي',
    profile: 'الملف الشخصي',
    
    // Home Page
    restaurantMenu: 'قائمة المطعم',
    restaurantTagline: 'لقد أدرجنا أفضل الأطباق لك',
    popularItems: 'الأصناف الشائعة',
    mostPopular: 'الأكثر شعبية',
    seeAll: 'عرض الكل',
    allDishes: 'جميع الأطباق',
    popularDishes: 'أطباق شائعة',
    bestMealOfTheDay: 'أفضل وجبة اليوم',
    exclusiveDeals: 'عروض حصرية',
    orderNow: 'اطلب الآن',
    searchFoodPlaceholder: 'بحث عن طعام...',
    filter: 'تصفية',
    sortBy: 'ترتيب حسب',
    sortDefault: 'افتراضي',
    sortPriceLowToHigh: 'السعر: من الأقل إلى الأعلى',
    sortPriceHighToLow: 'السعر: من الأعلى إلى الأقل',
    sortNameAtoZ: 'الاسم: أ-ي',
    sortCategoryAtoZ: 'الفئات أ-ي',
    sort: 'ترتيب',
    filterByCategory: 'تصفية حسب الفئة',
    applyFilters: 'تطبيق',
    selectAllCategories: 'جميع الفئات',
    allItems: 'جميع الأصناف',
    browseMenu: 'تصفح القائمة',
    noItemsFound: 'لم يتم العثور على أصناف',
    searchMenuItems: 'ابحث في أصناف القائمة...',
    
    // Cart
    yourCart: 'سلة التسوق',
    cartEmpty: 'سلة التسوق فارغة',
    addItems: 'أضف بعض الأصناف اللذيذة للبدء!',
    orderSummary: 'ملخص الطلب',
    subtotal: 'المجموع الفرعي',
    tax: 'الضريبة',
    vat: 'ض.ق.م', // ضريبة القيمة المضافة
    serviceCharge: 'رسوم الخدمة',
    total: 'الإجمالي',
    proceedToCheckout: 'المتابعة إلى الدفع',
    confirmOrder: 'تأكيد الطلب',
    fullNameOptional: 'الاسم الكامل (اختياري)',
    phoneNumberRequired: 'رقم الجوال',
    mobileRequired: 'رقم الجوال مطلوب',
    phone10Digits: 'الرجاء إدخال رقم جوال صحيح (10 أرقام)',
    size: 'الحجم',
    addons: 'الإضافات',
    note: 'ملاحظة',
    
    // Checkout
    customerInformation: 'معلومات العميل',
    mobileNumber: 'رقم الجوال',
    name: 'الاسم',
    optional: 'اختياري',
    tableNumber: 'رقم الطاولة',
    tableNumberPlaceholder: 'رقم الطاولة إذا كنت تتناول الطعام في المطعم',
    specialInstructions: 'تعليمات خاصة',
    specialInstructionsPlaceholder: 'أي طلبات أو تعليمات خاصة؟',
    placeOrder: 'تأكيد الطلب',
    placingOrder: 'جاري تأكيد الطلب...',
    required: 'مطلوب',
    validMobileNumber: 'الرجاء إدخال رقم جوال صحيح',
    
    // Order Confirmation
    orderPlaced: 'تم تأكيد الطلب!',
    orderPlacedMessage: 'شكراً لطلبك. سنقوم بإعداده على الفور.',
    orderSuccess: 'تم استلام الطلب',
    yourOrder: 'طلبك',
    showQRToWaiter: 'اعرض رمز QR هذا للطاقم',
    waiterScanHint: 'سيقوم الطاقم بمسح الرمز لإضافة الطلب إلى طاولتك',
    orderNumber: 'رقم الطلب',
    needHelp: 'تحتاج مساعدة؟',
    viewMyOrders: 'عرض طلباتي',
    backToMenu: 'العودة إلى القائمة',
    
    // Item Detail
    foodDetails: 'تفاصيل الطبق',
    quantity: 'الكمية',
    addToCart: 'إضافة إلى السلة',
    addToOrder: 'إضافة إلى الطلب',
    viewCart: 'عرض السلة',
    ingredients: 'المكونات',
    recommendedSides: 'أطباق جانبية مقترحة',
    weAlsoHave: 'نوفر أيضاً',
    allergens: 'مسببات الحساسية',
    specialRequests: 'طلبات خاصة',
    specialRequestsPlaceholder: 'أي طلبات خاصة؟',
    
    // My Orders
    viewMyOrdersTitle: 'عرض طلباتي',
    enterPhoneAndOrder: 'أدخل رقم جوالك ورقم الطلب لعرض طلباتك',
    phoneNumber: 'رقم الجوال',
    orderNumberInput: 'رقم الطلب',
    orderNumberPlaceholder: 'ORD-20250109-1234',
    orderNumberHint: 'يمكنك العثور على هذا في صفحة تأكيد الطلب',
    viewOrders: 'عرض الطلبات',
    verifying: 'جاري التحقق...',
    invalidPhoneOrOrder: 'رقم الجوال أو رقم الطلب غير صحيح. يرجى التحقق والمحاولة مرة أخرى.',
    noOrdersFound: 'لم يتم العثور على طلبات',
    noOrdersMessage: 'لم تقم بتقديم أي طلبات بعد.',
    orderDetails: 'تفاصيل الطلب',
    leaveReviewOnGoogle: 'أترك لنا تقييمك على خرائط جوجل',
    leaveReviewOnLine1: 'أترك لنا تقييمك على',
    leaveReviewOnLine2: 'خرائط جوجل',
    items: 'الأصناف',
    item: 'صنف',
    status: 'الحالة',
    pending: 'قيد الانتظار',
    confirmed: 'مؤكد',
    preparing: 'قيد التحضير',
    ready: 'جاهز',
    completed: 'مكتمل',
    cancelled: 'ملغي',
    
    // Category View
    category: 'الفئة',
    noItemsInCategory: 'لا توجد أصناف في هذه الفئة',
    
    // Errors
    failedToLoad: 'فشل التحميل',
    failedToLoadMenu: 'فشل تحميل القائمة',
    failedToPlaceOrder: 'فشل تأكيد الطلب. يرجى المحاولة مرة أخرى.',
    failedToLoadOrders: 'فشل تحميل الطلبات',

    // Reservation
    reservation: 'حجز',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    guests: 'الضيوف',
    date: 'التاريخ',
    time: 'الوقت',
    reserve: 'احجز',
    reservationSuccess: 'تم إرسال طلب الحجز',
    reservationSuccessMessage: 'سنؤكد حجزك قريباً.',
    reservationSuccessHint: 'سنخبرك عند تأكيد الحجز. يمكنك أيضاً الاتصال بنا لأي استفسار.',
    reservationFailed: 'فشل إرسال الحجز. يرجى المحاولة مرة أخرى.',
  }
}

export type Language = 'en' | 'ar'
export type TranslationKey = keyof typeof translations.en


